module.exports = __webpack_public_path__ + "static/media/product-2.40524468.svg";